<template>
  <div>
    <div v-if="formKey === 'icon'">
      <div class="flex">
        <el-image v-show="formItem.value" class="mr-10 icon inline-block" fit="cover" :src="formItem.value" />
        <div>
          <el-button v-if="!formItem.isPreview" size="mini" type="primary" @click="openMaterialBox('image', formItem)">{{ formItem.value ? '替换' : '添加' }}图标</el-button>
        </div>
      </div>
      <!-- 素材弹框 -->
      <material-box
        v-if="formItem.is_open"
        advertiser="huawei"
        :is-open="formItem.is_open"
        :type="formItem.box_type"
        :temp-material="formItem.temp_material"
        :material-restriction="formItem.material_restriction"
        @confirm="(m_data, m_type) => materialConfirm({ data: m_data, type: m_type, material: formItem })"
        @cancel="materialCancel(formItem)"
      />
    </div>
    <div v-if="formKey === 'description' && !formItem.isPreview">
      <div class="word-list">
        <el-link v-for="word in formItem.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="formItem.value += `{${word}}`">+{{ word }}</el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';

export default {
  components: {
    'material-box': () => import('@/components/material-box'),
  },
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 打开素材框
     * @param {string} type 素材类型
     */
    openMaterialBox(type, material_item) {
      if (material_item) {
        material_item.temp_material = null;
        material_item.is_open = true;
        material_item.box_type = material_item.element_type || type;
      }
    },

    /**
     * @typedef {Object} MaterialData
     * @property {Array<Object>} data - 素材数据
     * @property {string} type - 素材类型
     * @property {Object} material - 表单配置项
     */
    /**
     * 素材资源确定返回
     * @param {MaterialData} data - 返回数据
     */
    async materialConfirm({ data, type, material }) {
      type = (type === 'element_story') ? 'image' : type;
      material.is_open = false;

      if (data.length === 0) {
        return;
      }

      if ((data.length > material.limit) && !material.temp_material) {
        this.$message.warning(`图标不能超过${material.limit}个！`);
        return;
      }
      material.value = data[0].url[0].url;
      this.$parent.$parent.$parent.validateField('icon.value');
    },

    /**
     * 素材资源取消返回
     * @param {Object} material 素材配置项
     */
    materialCancel(material) {
      material.is_open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 100px;
  height: 100px;
  font-size: 0;
}
</style>
